"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementStatusModel = void 0;
var SettlementStatusModel;
(function (SettlementStatusModel) {
    SettlementStatusModel["NOT_RECEIVED"] = "NOT_RECEIVED";
    SettlementStatusModel["SKIPPED"] = "SKIPPED";
    SettlementStatusModel["CREDITED"] = "CREDITED";
    SettlementStatusModel["SCHEDULED"] = "SCHEDULED";
    SettlementStatusModel["CANCELLED"] = "CANCELLED";
    SettlementStatusModel["PENDING"] = "PENDING";
    SettlementStatusModel["PAID"] = "PAID";
    SettlementStatusModel["FAILED"] = "FAILED";
    SettlementStatusModel["MANUAL_PAYMENT_REQUIRED"] = "MANUAL_PAYMENT_REQUIRED";
    SettlementStatusModel["PAID_MANUALLY"] = "PAID_MANUALLY";
})(SettlementStatusModel = exports.SettlementStatusModel || (exports.SettlementStatusModel = {}));
//# sourceMappingURL=settlements.js.map